import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  StreamTranscodingConfiguration,
  StreamTranscodingConfigurationWebSocketAction,
  StreamTranscodingConfigurationWebSocketMessage
} from './stream-transcoding-configuration.interface';
import {
  createStreamTranscodingConfigurationSuccess,
  deleteStreamTranscodingConfigurationSuccess,
  updateStreamTranscodingConfigurationSuccess
} from '../../../store/stream-transcoding-configurations';

@Injectable({providedIn: 'root'})
export class StreamTranscodingConfigurationsWebSocketService {

  constructor(
    private readonly store: Store
  ) {
  }

  public receiveMessage(message: StreamTranscodingConfigurationWebSocketMessage): void {
    const action: StreamTranscodingConfigurationWebSocketAction = message.action;
    const data: StreamTranscodingConfiguration = message.data;

    switch (action) {
      case 'create':
        this.store.dispatch(createStreamTranscodingConfigurationSuccess({item: data}));
        break;
      case 'update':
        this.store.dispatch(updateStreamTranscodingConfigurationSuccess({item: data}));
        break;
      case 'delete':
        this.store.dispatch(deleteStreamTranscodingConfigurationSuccess({id: data.id}));
        break;
    }
  }
}

